import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../config/firebase';

// Admin accounts configuration
const ADMIN_ACCOUNTS = [
  {
    email: 'admin@lsem.org.ng',
    password: 'LSEM2024Admin!', // Change this to your preferred password
  },
  {
    email: 'info@lsem.org.ng',
    password: 'LSEM2024Info!', // Change this to your preferred password
  }
];

// Function to create admin accounts (run this once)
export const createAdminAccounts = async () => {
  const results = [];
  
  for (const account of ADMIN_ACCOUNTS) {
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth, 
        account.email, 
        account.password
      );
      results.push({
        email: account.email,
        success: true,
        uid: userCredential.user.uid
      });
      console.log(`✅ Admin account created: ${account.email}`);
    } catch (error: any) {
      if (error.code === 'auth/email-already-in-use') {
        results.push({
          email: account.email,
          success: true,
          message: 'Account already exists'
        });
        console.log(`ℹ️ Admin account already exists: ${account.email}`);
      } else {
        results.push({
          email: account.email,
          success: false,
          error: error.message
        });
        console.error(`❌ Failed to create admin account ${account.email}:`, error.message);
      }
    }
  }
  
  return results;
};

// Function to test admin login
export const testAdminLogin = async (email: string, password: string) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    console.log(`✅ Admin login successful: ${email}`);
    return { success: true, user: userCredential.user };
  } catch (error: any) {
    console.error(`❌ Admin login failed: ${email}`, error.message);
    return { success: false, error: error.message };
  }
};

// Default admin credentials (for reference)
export const DEFAULT_ADMIN_CREDENTIALS = {
  'admin@lsem.org.ng': 'LSEM2024Admin!',
  'info@lsem.org.ng': 'LSEM2024Info!'
};